export default "__VITE_ASSET__4b4afede__"